import { useAuthContext } from "../../auth/state/AuthContext";
import { hasAnyFeatureAccess, hasFeatureAccess } from "../utils/feature-access";

export const useFeatureAccess = (featureKeys?: string | readonly string[]) => {
  const { state } = useAuthContext();
  const user = state.user;
  const accessControl = user?.accessControl ?? null;

  const hasFeature = (featureKey: string) => hasFeatureAccess(accessControl, featureKey);
  const hasAnyFeature = (keys: readonly string[]) => hasAnyFeatureAccess(accessControl, keys);
  const normalizedFeatureKeys = Array.isArray(featureKeys) ? featureKeys : featureKeys ? [featureKeys] : [];

  return {
    accessControl,
    grantedFeatures: accessControl?.grantedFeatures ?? [],
    hasAccess: normalizedFeatureKeys.length === 0 ? false : hasAnyFeature(normalizedFeatureKeys),
    hasAnyFeature,
    hasFeature,
    isLoading: user === null,
    matchedRoles: accessControl?.matchedRoles ?? [],
    source: accessControl?.source ?? "fallback",
  };
};
